module.exports = __webpack_public_path__ + "img/exoscale.7a312d6d.svg";